/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Cascader } from 'antd'
const { SHOW_CHILD } = Cascader

class FormCascader extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]), // 选项数据 数据需要经过 关联id grouBy
    disabledOption: PropTypes.array, // 禁用选项数据
  }
  static defaultProps = {
    allowClear: false,
    expandTrigger: 'hover', // 触发下级方式
    options: [],
    modalProps: {},
    style: { width: '100%' },
    disableOptionType: 'fullIds', // 需要禁用的key
    valid: true, // 基本可选范围 （true：可选生效 | false： 无效可选（包含生效））
  }

  renderTree = (roots = [], data) => {
    const { disabledOption, disableOptionType, valid } = this.props
    for (let i = 0; i < roots.length; i++) {
      if (disabledOption) {
        roots[i].disabled = disabledOption.some(e =>(
          e[disableOptionType]
            ? e[disableOptionType].join(',') === roots[i][disableOptionType].join(',')
            : false
        ))
      }
      // 默认 失效选择 不可选
      if (valid && !roots[i].valid) {
        roots[i].disabled = true
      }
      
      if (data[roots[i].id]) {
        roots[i].children = data[roots[i].id]
        this.renderTree(roots[i].children, data)
      }
    }
  }
  
  handleChange = (value, selectedOptions) => {
    console.log('Cascader value', value, 'selectedOptions', selectedOptions)
    const { onChange, actionChange } = this.props
    
    if (actionChange) {
      actionChange(value, selectedOptions)
    }
    if (onChange) {
      onChange(value, selectedOptions)
    }
  }
  
  render () {
    const { value, style, className, options, placeholder, expandTrigger, allowClear, modalProps, id } = this.props
    const rootTree = Array.isArray(options[0]) ? options[0] : []
    this.renderTree(rootTree, options)
    return(
      <Cascader
        id={id}
        showSearch={true}
        allowClear={true}
        placeholder={`请选择`}
        expandTrigger={expandTrigger}
        {...modalProps}
        showCheckedStrategy={SHOW_CHILD}

        value={value}
        style={style}
        className={className}
        options={rootTree}        
        onChange={this.handleChange}
      />
    )
  }
}
export default FormCascader

// options={grouByData}